// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-narrative-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px 20px 18px;
  border: 1px solid #b9d6f7;
  border-radius: 8px;
  background: #eef6ff;
  color: #24364d;
  box-sizing: border-box;
}
.dashboard-narrative-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.dashboard-narrative-panel__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.dashboard-narrative-panel__icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #2b74e4;
  fill: rgba(43, 116, 228, 0.1);
}
.dashboard-narrative-panel h3,
.dashboard-narrative-panel h4,
.dashboard-narrative-panel p,
.dashboard-narrative-panel ul {
  margin: 0;
}
.dashboard-narrative-panel h3 {
  color: #172033;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.25;
}
.dashboard-narrative-panel__title-row p {
  margin-top: 1px;
  color: #91a3b9;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
}
.dashboard-narrative-panel__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}
.dashboard-narrative-panel__switch-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashboard-narrative-panel__switch-label {
  color: #6f7f92;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}
.dashboard-narrative-panel__switch {
  position: relative;
  flex: 0 0 auto;
  width: 40px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 11px;
  background: #cbd5e1;
  cursor: pointer;
  transition: background-color 0.18s ease;
}
.dashboard-narrative-panel__switch--on {
  background: #2b74e4;
}
.dashboard-narrative-panel__switch:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.dashboard-narrative-panel__switch:focus-visible {
  outline: 3px solid rgba(43, 116, 228, 0.22);
  outline-offset: 2px;
}
.dashboard-narrative-panel__switch-knob {
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  transition: transform 0.18s ease;
}
.dashboard-narrative-panel__switch--on .dashboard-narrative-panel__switch-knob {
  transform: translateX(18px);
}
[dir=rtl] .dashboard-narrative-panel__switch--on .dashboard-narrative-panel__switch-knob {
  transform: translateX(-18px);
}
.dashboard-narrative-panel__toggle, .dashboard-narrative-panel__dismiss {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #2b74e4;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease;
}
.dashboard-narrative-panel__toggle:hover, .dashboard-narrative-panel__dismiss:hover {
  background: rgba(43, 116, 228, 0.08);
  color: #185ebd;
}
.dashboard-narrative-panel__toggle:focus-visible, .dashboard-narrative-panel__dismiss:focus-visible {
  outline: 3px solid rgba(43, 116, 228, 0.22);
  outline-offset: 2px;
}
.dashboard-narrative-panel__dismiss {
  color: #6f7f92;
}
.dashboard-narrative-panel__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dashboard-narrative-panel__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
}
.dashboard-narrative-panel__copy {
  color: #2f4158;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.01em;
}
.dashboard-narrative-panel__segment--positive {
  color: #1f9d63;
  font-weight: 700;
  margin-right: 2px;
  padding: 0 2px;
}
.dashboard-narrative-panel__segment--negative {
  color: #c9472c;
  font-weight: 700;
  margin-right: 2px;
  padding: 0 2px;
}
.dashboard-narrative-panel__segment--neutral {
  color: inherit;
  margin-right: 2px;
}
.dashboard-narrative-panel__inline-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-left: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2b74e4;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  vertical-align: baseline;
  transition: color 0.18s ease, text-decoration-color 0.18s ease;
}
.dashboard-narrative-panel__inline-toggle:hover {
  color: #185ebd;
  text-decoration-color: #185ebd;
}
.dashboard-narrative-panel__inline-toggle:focus-visible {
  outline: 2px solid rgba(43, 116, 228, 0.28);
  outline-offset: 2px;
  border-radius: 3px;
}
.dashboard-narrative-panel__inline-toggle svg {
  flex: 0 0 auto;
  stroke-width: 2.4;
}
.dashboard-narrative-panel__details {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.dashboard-narrative-panel__section-title {
  margin-bottom: 4px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.25;
}
.dashboard-narrative-panel__section-title--insights, .dashboard-narrative-panel__section-title--recommendations {
  color: #2b74e4;
}
.dashboard-narrative-panel__list-block ul {
  padding-left: 0;
  list-style: none;
  color: #2f4158;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}
.dashboard-narrative-panel__list-block li {
  margin: 8px 0;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.dashboard-narrative-panel__list-item--with-icon {
  align-items: center;
  gap: 12px;
}
.dashboard-narrative-panel__list-text {
  display: inline;
  color: #1e293b;
  font-weight: 400;
  flex: 1 1;
}
.dashboard-narrative-panel__list-text strong,
.dashboard-narrative-panel__list-text b {
  font-weight: 700;
  color: #0f172a;
}
.dashboard-narrative-panel__list-icon {
  flex: 0 0 auto;
}
.dashboard-narrative-panel__list-icon--positive, .dashboard-narrative-panel__list-icon--negative {
  display: block;
}
.dashboard-narrative-panel__list-icon--arrow {
  color: #64748b;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  stroke-width: 2.5;
}
[dir=rtl] .dashboard-narrative-panel__list-icon--arrow {
  transform: scaleX(-1);
}
.dashboard-narrative-panel--collapsed {
  padding-bottom: 16px;
}
.dashboard-narrative-panel--disabled {
  border-color: #e2e8f0;
  background: #f4f6f9;
}
.dashboard-narrative-panel--disabled .dashboard-narrative-panel__copy {
  color: #6f7f92;
}
.dashboard-narrative-panel--disabled .dashboard-narrative-panel__icon {
  color: #6f7f92;
  fill: rgba(111, 127, 146, 0.1);
}
.dashboard-narrative-panel--disabled .dashboard-narrative-panel__toggle {
  color: #6f7f92;
}
.dashboard-narrative-panel--disabled .dashboard-narrative-panel__toggle:hover {
  background: rgba(111, 127, 146, 0.08);
  color: #576273;
}
.dashboard-narrative-panel--limit {
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  min-height: 104px;
}
.dashboard-narrative-panel__limit-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.dashboard-narrative-panel__limit-copy p {
  color: #8ba0ba;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
}

@media (max-width: 768px) {
  .dashboard-narrative-panel {
    padding: 18px 18px 20px;
  }
  .dashboard-narrative-panel h3 {
    font-size: 16px;
  }
  .dashboard-narrative-panel--limit {
    min-height: 0;
  }
  .dashboard-narrative-panel__title-row {
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardNarrativePanel/DashboardNarrativePanel.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AADJ;AAIE;;;;EAIE,SAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAME;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANJ;AASE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;AARJ;AAUI;EACE,mBAAA;AARN;AAWI;EACE,mBAAA;EACA,YAAA;AATN;AAYI;EACE,2CAAA;EACA,mBAAA;AAVN;AAcE;EACE,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAZJ;AAeE;EACE,2BAAA;AAbJ;AAgBE;EACE,4BAAA;AAdJ;AAiBE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AAhBJ;AAkBI;EACE,oCAAA;EACA,cAAA;AAhBN;AAmBI;EACE,2CAAA;EACA,mBAAA;AAjBN;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApBJ;AAuBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,iBAAA;AAzBJ;AA4BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,8DAAA;AA1BJ;AA4BI;EACE,cAAA;EACA,8BAAA;AA1BN;AA6BI;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;AA3BN;AA8BI;EACE,cAAA;EACA,iBAAA;AA5BN;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9BJ;AAiCE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/BJ;AAkCE;EAEE,cAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAnCJ;AAsCE;EACE,mBAAA;EACA,SAAA;AApCJ;AAuCE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AArCJ;AAuCI;;EAEE,gBAAA;EACA,cAAA;AArCN;AAyCE;EACE,cAAA;AAvCJ;AAyCI;EAEE,cAAA;AAxCN;AA2CI;EACE,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAzCN;AA6CI;EACE,qBAAA;AA3CN;AA+CE;EACE,oBAAA;AA7CJ;AAgDE;EACE,qBAAA;EACA,mBAAA;AA9CJ;AAgDI;EACE,cAAA;AA9CN;AAiDI;EACE,cAAA;EACA,8BAAA;AA/CN;AAkDI;EACE,cAAA;AAhDN;AAkDM;EACE,qCAAA;EACA,cAAA;AAhDR;AAqDE;EACE,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AApDJ;AAuDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDJ;;AAyDA;EACE;IACE,uBAAA;EAtDF;EAwDE;IACE,eAAA;EAtDJ;EAyDE;IACE,aAAA;EAvDJ;EA0DE;IACE,SAAA;EAxDJ;AACF","sourcesContent":[".dashboard-narrative-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding: 16px 20px 18px;\n  border: 1px solid #b9d6f7;\n  border-radius: 8px;\n  background: #eef6ff;\n  color: #24364d;\n  box-sizing: border-box;\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__icon {\n    flex: 0 0 auto;\n    margin-top: 2px;\n    color: #2b74e4;\n    fill: rgba(43, 116, 228, 0.1);\n  }\n\n  h3,\n  h4,\n  p,\n  ul {\n    margin: 0;\n  }\n\n  h3 {\n    color: #172033;\n    font-size: 17px;\n    font-weight: 800;\n    line-height: 1.25;\n  }\n\n  &__title-row p {\n    margin-top: 1px;\n    color: #91a3b9;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1.3;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 0 0 auto;\n  }\n\n  &__switch-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__switch-label {\n    color: #6f7f92;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n  }\n\n  &__switch {\n    position: relative;\n    flex: 0 0 auto;\n    width: 40px;\n    height: 22px;\n    padding: 0;\n    border: 0;\n    border-radius: 11px;\n    background: #cbd5e1;\n    cursor: pointer;\n    transition: background-color 0.18s ease;\n\n    &--on {\n      background: #2b74e4;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba(43, 116, 228, 0.22);\n      outline-offset: 2px;\n    }\n  }\n\n  &__switch-knob {\n    position: absolute;\n    top: 3px;\n    inset-inline-start: 3px;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: #ffffff;\n    transition: transform 0.18s ease;\n  }\n\n  &__switch--on &__switch-knob {\n    transform: translateX(18px);\n  }\n\n  [dir=\"rtl\"] &__switch--on &__switch-knob {\n    transform: translateX(-18px);\n  }\n\n  &__toggle,\n  &__dismiss {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #2b74e4;\n    cursor: pointer;\n    transition: background-color 0.18s ease, color 0.18s ease;\n\n    &:hover {\n      background: rgba(43, 116, 228, 0.08);\n      color: #185ebd;\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba(43, 116, 228, 0.22);\n      outline-offset: 2px;\n    }\n  }\n\n  &__dismiss {\n    color: #6f7f92;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 48px;\n  }\n\n  &__copy {\n    color: #2f4158;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.01em;\n  }\n\n  &__segment--positive {\n    color: #1f9d63;\n    font-weight: 700;\n    margin-right: 2px;\n    padding: 0 2px;\n  }\n\n  &__segment--negative {\n    color: #c9472c;\n    font-weight: 700;\n    margin-right: 2px;\n    padding: 0 2px;\n  }\n\n  &__segment--neutral {\n    color: inherit;\n    margin-right: 2px;\n  }\n\n  &__inline-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    margin-left: 2px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #2b74e4;\n    font-family: inherit;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: inherit;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    cursor: pointer;\n    vertical-align: baseline;\n    transition: color 0.18s ease, text-decoration-color 0.18s ease;\n\n    &:hover {\n      color: #185ebd;\n      text-decoration-color: #185ebd;\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(43, 116, 228, 0.28);\n      outline-offset: 2px;\n      border-radius: 3px;\n    }\n\n    svg {\n      flex: 0 0 auto;\n      stroke-width: 2.4;\n    }\n  }\n\n  &__details {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  &__section-title {\n    margin-bottom: 4px;\n    font-size: 15px;\n    font-weight: 800;\n    line-height: 1.25;\n  }\n\n  &__section-title--insights,\n  &__section-title--recommendations {\n    color: #2b74e4;\n  }\n\n  &__list-block ul {\n    padding-left: 0;\n    list-style: none;\n    color: #2f4158;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.5;\n  }\n\n  &__list-block li {\n    margin: 8px 0;\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  &__list-item--with-icon {\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__list-text {\n    display: inline;\n    color: #1e293b;\n    font-weight: 400;\n    flex: 1;\n\n    strong,\n    b {\n      font-weight: 700;\n      color: #0f172a;\n    }\n  }\n\n  &__list-icon {\n    flex: 0 0 auto;\n\n    &--positive,\n    &--negative {\n      display: block;\n    }\n\n    &--arrow {\n      color: #64748b;\n      background-color: transparent;\n      border-radius: 0;\n      padding: 0;\n      stroke-width: 2.5;\n    }\n\n    // Mirrors the directional arrow icon so it points inline-end in RTL.\n    [dir=\"rtl\"] &--arrow {\n      transform: scaleX(-1);\n    }\n  }\n\n  &--collapsed {\n    padding-bottom: 16px;\n  }\n\n  &--disabled {\n    border-color: #e2e8f0;\n    background: #f4f6f9;\n\n    .dashboard-narrative-panel__copy {\n      color: #6f7f92;\n    }\n\n    .dashboard-narrative-panel__icon {\n      color: #6f7f92;\n      fill: rgba(111, 127, 146, 0.1);\n    }\n\n    .dashboard-narrative-panel__toggle {\n      color: #6f7f92;\n\n      &:hover {\n        background: rgba(111, 127, 146, 0.08);\n        color: #576273;\n      }\n    }\n  }\n\n  &--limit {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    min-height: 104px;\n  }\n\n  &__limit-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__limit-copy p {\n    color: #8ba0ba;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.45;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-narrative-panel {\n    padding: 18px 18px 20px;\n\n    h3 {\n      font-size: 16px;\n    }\n\n    &--limit {\n      min-height: 0;\n    }\n\n    &__title-row {\n      gap: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
